import { useAuth } from '@/contexts/auth-context';
import * as analytics from '@/lib/services/analytics';
import { usePathname, useSegments } from 'expo-router';
import { ReactNode, useEffect, useRef } from 'react';
import { Platform } from 'react-native';

type AnalyticsProviderProps = {
  children: ReactNode;
};

const isNative = Platform.OS === 'ios' || Platform.OS === 'android';

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const pathname = usePathname();
  const segments = useSegments();
  const { user } = useAuth();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (!isNative) {
      return;
    }

    if (user?.id) {
      void analytics.setUserId(String(user.id));
      void analytics.setUserProperties({
        user_role: user.role,
      });
      return;
    }

    void analytics.setUserId(null);
  }, [user?.id, user?.role]);

  useEffect(() => {
    if (!isNative || !pathname || pathname === previousPath.current) {
      return;
    }

    previousPath.current = pathname;

    const screenName = segments.length > 0 ? segments.join('/') : pathname;

    void analytics.logScreenView(screenName, pathname);
  }, [pathname, segments]);

  return <>{children}</>;
}
